const SUBSCRIPTION_TYPE = {
  ADDON: "addon",
  DEFAULT: "default",
  SHOPPING_CART: "shopping-cart",
};

export default SUBSCRIPTION_TYPE;
